import styled from "styled-components";

export const Container = styled.div`
   width: 100%;
   height: 100vh;
   background: #ffffff;
   box-shadow: inset 0px 54px 134px rgba(0, 0, 0, 0.15);

   background-color: white;
   display: flex;
   flex-direction: column;
   justify-content: center;
`;
export const GeneralCont = styled.div`
   width: 100%;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;

   form {
      margin-top: 50px;
      width: 313px;
   }

   .styleInput {
      margin-left: auto;
      margin-right: auto;
      display: block;
      font-weight: 300;
      font-size: 14px;
      padding: 10px 14px;
      width: 100%;
      border-bottom: 0.5px solid #dadada;
      border-top-color: #7fffd400;
      border-right-color: #7fffd400;
      border-left-color: #7fffd400;
      outline: none;
      box-sizing: border-box;
   }

   button {
      color: #1c355e;
      width: 100%;
      font-weight: bold;
   }
   .styleTxtLogin1 {
      margin-left: auto;
      margin-right: auto;
      display: block;
      margin-top: 26px;
      width: 172px;
      text-align: center;
      font-size: 14px;
      font-weight: 300;
      color: #b6b6b6;
      text-decoration: none;
      position: relative;

      &:after {
         content: "";
         position: absolute;
         width: 80%;
         left: 10%;
         border-bottom: 1px solid #b6b6b6;
         bottom: -2px;
      }
   }
`;
